import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { C4SEAS_NAERLS_WEBSITE_URL } from "../../../constants/links";
import { useTranslation } from "react-i18next";

function SFRFooter() {
  const {t} = useTranslation();

  return (
    <View style={styles.footer}>
      <Text style={styles.footerLine}>─────────────────────────────────────────────────</Text>
      <Text style={styles.footerLine}>
        C4SEAS Regional Training Hub Project | NAERLS | SAA | ABU{"\n"}
        {C4SEAS_NAERLS_WEBSITE_URL}
      </Text>

      <Text style={styles.disclaimer}>
        {t("pdf.disclaimer")}
      </Text>

      <Text style={styles.attribution}>
        Generated by C4SEAS • NAERLS | Report ID: {new Date().getTime()}
      </Text>
    </View>
  );
}

export default SFRFooter;

const styles = StyleSheet.create({
  footer: {
    marginTop: 25,
    paddingTop: 15,
    borderTopWidth: 2,
    borderTopColor: "#e5e7eb",
  },

  footerLine: {
    fontSize: 9,
    color: "#6b7280",
    marginBottom: 3,
    textAlign: "center",
  },

  disclaimer: {
    fontSize: 8,
    color: "#9ca3af",
    marginTop: 10,
    textAlign: "center",
    fontStyle: "italic",
    lineHeight: 1.4,
  },

  attribution: {
    fontSize: 8,
    color: "#9ca3af",
    marginTop: 5,
    textAlign: "center",
  },
});
